import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import _ from "underscore";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {showToastMessage} from "../../../modules/toast";
import {GET_JOSA, NAVER_THUMBNAIL_GETTER} from "../../../modules/variable/common_variable";

class InterestingPlaceActionSheet extends React.Component {
    state = {
        interestingPlace: [],
        iframeActionSheet: {open: false, frameUrl: null},
    };

    componentDidMount(){
        let parsedInterestingPlace = [];
        if(localStorage.getItem('savedInterestingPlace')){
            try {
                parsedInterestingPlace = JSON.parse(localStorage.getItem('savedInterestingPlace'));
            } catch (e) {console.error(e);}
        }

        this.setState({interestingPlace: parsedInterestingPlace})
    }

    deleteInterestingPlace = (event, e) => {
        const josa = GET_JOSA(e.name, '을');
        
        if (window.confirm(e.name + josa + " 관심 장소에서 삭제하시겠습니까?") === true){
            let interestingPlace = this.state.interestingPlace;
            const placeIndex = _.findIndex(interestingPlace, {id: e.id});
            interestingPlace.splice(placeIndex, 1);
            localStorage.setItem('savedInterestingPlace', JSON.stringify(interestingPlace));
            this.setState({interestingPlace: interestingPlace});
            this.props.showToastMessage('관심 장소를 삭제하였습니다.');
        }
    };

    render() {
        return (
            <div>
                <ActionSheet className="interesting-place-action-sheet" isOpen={true} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true}>
                    <div className="action-sheet-title action-sheet-title--material">
                        관심 장소
                    </div>
                    <ul className="list list--material">
                        {
                            this.state.interestingPlace.length === 0 ?
                                <li className="list-item list-item--material">
                                    <div className="list-item__center list-item--material__center">
                                        <div className="list-item__title list-item--material__title text-center">
                                            등록된 관심 장소가 없습니다.
                                        </div>
                                    </div>
                                </li>
                                :
                                null
                        }
                        {
                            this.state.interestingPlace.map((e, i) => {
                                return (
                                    <li key={['traffic', 'condition', i].join('_')} className="list-item list-item--material">
                                        <div className="list-item__left list-item--material__left" onClick={() => this.setState({iframeActionSheet: {open: true, frameUrl: 'https://m.store.naver.com/attractions/detail?id=' + e.id + '&back=false'}})}>
                                            <img className="list-item__thumbnail" src={NAVER_THUMBNAIL_GETTER(e)} alt={e.name} onError={(event)=>{event.target.src = "https://fakeimg.pl/100x100/?text=No Image"}}/>
                                        </div>
                                        <div className="list-item__center list-item--material__center" onClick={() => this.setState({iframeActionSheet: {open: true, frameUrl: 'https://m.store.naver.com/attractions/detail?id=' + e.id + '&back=false'}})}>
                                            <div className="list-item__title list-item--material__title">{e.name}</div>
                                            <div className="list-item__subtitle list-item--material__subtitle">{e.tags ? e.tags.join(", ") : null}</div>
                                        </div>
                                        {
                                            this.props.importable ?
                                                <div className="list-item__right list-item--material__right" onClick={(event) => this.props.importSchedule(event, e, e.type)}>
                                                    <button className="fab fab--mini"><i className="fa fa-plus"></i></button>
                                                </div>
                                                :
                                                <div className="list-item__right list-item--material__right">
                                                    {/*<span className={['notification', 'notification--material', 'notification-' + e.type].join(' ')}>{e.type === 'playing' ? '놀곳' : e.type === 'eating' ? '먹을곳' : '잘곳'}</span>*/}
                                                    <span onClick={(event) => this.deleteInterestingPlace(event, e)}><i className="fa fa-minus"/></span>
                                                </div>
                                        }
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <ActionSheetButton className="action-sheet-close" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>관심 장소 닫기</ActionSheetButton>
                </ActionSheet>

                {
                    this.state.iframeActionSheet.open ?
                        <ActionSheet className="iframe-action-sheet" isOpen={this.state.iframeActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} isCancelable={true} title={'이하 정보는 네이버 사이트입니다.'}>
                            <iframe id="iframe-action-sheet" title="iframe-action-sheet" src={this.state.iframeActionSheet.frameUrl}></iframe>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showToastMessage: message => dispatch(showToastMessage(message))
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(InterestingPlaceActionSheet))

